import {
  Autocomplete,
  Box,
  CircularProgress,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomPagination from "../CustomPagination";
import { GET_CUSTOMER_BILLING_TABLE } from "../../../constants/ApiRoute";
import { authHeader } from "../../comman/MainFunction";
import { deCryptFun, enCryptFun } from "../../comman/CustomFunction";
import API from "../../comman/API";
import moment from "moment";
import sortupdownarrowIcon from "../../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../../images/sort_down_arrow.svg";
import NoRecordFound from "../../comman/NoRecordFound";

export default function BillingTable(props) {
  const { customerTab, setCustomerTab } = props;

  const [sortedData, setSorteddata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "BillingHeaderID",
    direction: "asc",
  });
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [sortClickedTime, setSortClickedTime] = useState("");
  const rowsPerPage = 5;
  console.log(sortedData, "1111newwwwwwwwwwwwwwwwwwwww", page);

  const formatNumber = (number) => {
    return number.toString().padStart(2, "0");
  };

  const handlePageChange = (event, newPage) => {
    console.log(newPage, "newPagenewPagenewPage");
    setPage(newPage);
  };

  const handleSearchChange = (event, value) => {
    setSearchQuery(value);
    setPage(1); // Reset page to 1 when search query changes
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";

    let orderValue = isAsc ? "desc" : "asc";

    setOrder(orderValue);
    setOrderBy(property);

    if (order === "desc") {
      setOrder("");
      setOrderBy("");
    }

    if (orderBy != property) {
      setOrder("asc");
      setOrderBy(property);
    }

    setPage(1);
    setSortClickedTime(new Date().toLocaleString());

    // setSortConfig((prevState) => ({
    //   key,
    //   direction: prevState.direction === "asc" ? "desc" : "asc",
    // }));
  };

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  const sortData = (data, key, direction) => {
    console.log(key, "ddkdkkjdsjdkjsk", direction);
    return data.sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  const fieldsToSearch = [
    "RowGroup",
    "BillingHeaderID",
    "Broker",
    "DayRate",
    "Hours",
    "Status",
    "Others",
    "Total",
  ];

  // Filter the entire dataset
  const filteredData = sortedData.filter((item) => {
    // Calculate `otherCount` and `totalValue` for each item
    const otherCount =
      item?.PerDiem +
      item?.Lodging +
      item?.Copies +
      item?.Misc +
      item?.Miles * item?.MileageRate;

    const totalValue =
      item?.PerDiem +
      item?.Lodging +
      item?.Copies +
      item?.Misc +
      item?.Miles * item?.MileageRate +
      (item?.Hours / 8) * item?.DayRate;

    // Check if any of the fields match the search query
    const matchesFields = fieldsToSearch.some((field) => {
      const fieldValue = item[field];
      return (
        fieldValue &&
        String(fieldValue).toLowerCase().includes(searchQuery.toLowerCase())
      );
    });

    // Check if `otherCount` or `totalValue` matches the search query
    const matchesDerivedValues =
      (otherCount &&
        String(otherCount).toLowerCase().includes(searchQuery.toLowerCase())) ||
      (totalValue &&
        String(totalValue).toLowerCase().includes(searchQuery.toLowerCase()));

    // Return true if any field or derived value matches the search query
    return matchesFields || matchesDerivedValues;
  });

  // Calculate total pages based on filtered data
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  // Paginate the filtered data
  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    (page - 1) * rowsPerPage + rowsPerPage
  );

  const groupedData = paginatedData.reduce((acc, curr) => {
    const projId = curr.RowGroup;
    if (!acc[projId]) {
      acc[projId] = [];
    }
    acc[projId].push(curr);
    return acc;
  }, {});

  const getCustomerBillingDetails = async (custId) => {
    setLoading(true);
    let data = {
      customerId: customerTab?.customerId ? customerTab?.customerId : custId,
      sort: order,
      orderBy: orderBy,
    };
    const config = {
      method: "GET",
      url: GET_CUSTOMER_BILLING_TABLE,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;
      if (status === "Success") {
        const transformedData = data
        .map((item) => ({
          ...item,
        }))
        .sort((a, b) => {
          // Sort by BillingStart in descending order (recent dates first)
          return new Date(b.BillingStart) - new Date(a.BillingStart);
        });
      
      // Output the transformed data
      console.log(transformedData);
      
    
    console.log(transformedData);
       console.log(transformedData, 'transformedDatatransformedData')


        const sorted = sortData(transformedData, orderBy, order);
        setSorteddata(transformedData);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCustomerBillingDetails(customerTab.custId);
  }, [customerTab.custId, order, orderBy]);

  const handleBrokerNavigate = (val) => {
    if (val) {
      setCustomerTab((prevState) => ({
        ...prevState,
        brokerId: val,
      }));
    }
  };

  const handleBillingNavigate = (val) => {
    if (val.BillingHeaderID) {
      const url = `/print-dashboard-billing-statements/${val.BillingHeaderID}`;
      window.open(url, "_blank"); // Opens the URL in a new tab
    }
  };

  return (
    <div>
      <Stack
        sx={{ mb: "20px" }}
        direction={{ xs: "column", sm: "row", md: "row" }}
        alignItems={{ xs: "baseline", sm: "center", md: "center" }}
        justifyContent="space-between"
      >
        <Autocomplete
          sx={{ maxWidth: "265px", width: "100%" }}
          freeSolo
          id="free-solo-2-demo"
          disableClearable
          startAdornment={
            <InputAdornment position="start">
              <span className="material-symbols-outlined">search</span>
            </InputAdornment>
          }
          options={[]}
          onInputChange={handleSearchChange}
          renderInput={(params) => (
            <TextField
              placeholder="Search"
              {...params}
              InputProps={{
                ...params.InputProps,
                type: "search",
              }}
            />
          )}
        />
      </Stack>
      <TableContainer sx={{ boxShadow: "none" }} component={Paper}>
        <Table
          // sx={{ minWidth: 650 }}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === "BillingHeaderID"}
                  direction={orderBy === "BillingHeaderID" ? order : "asc"}
                  onClick={() => handleSort("BillingHeaderID")}
                  IconComponent={() => getSortIcon("BillingHeaderID")}
                  style={
                    orderBy === "BillingHeaderID" ? { color: "#007fff" } : {}
                  }
                  // active={sortConfig.key === "BillingHeaderID"}
                  // direction={
                  //   sortConfig.key === "BillingHeaderID"
                  //     ? sortConfig.direction
                  //     : "asc"
                  // }
                  // onClick={() => handleSort("BillingHeaderID")}
                > */}
                ID
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === "Broker"}
                  direction={orderBy === "Broker" ? order : "asc"}
                  onClick={() => handleSort("Broker")}
                  IconComponent={() => getSortIcon("Broker")}
                  style={orderBy === "Broker" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Broker"}
                  // direction={
                  //   sortConfig.key === "Broker" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Broker")}
                > */}
                Broker Name
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === "DayRate"}
                  direction={orderBy === "DayRate" ? order : "asc"}
                  onClick={() => handleSort("DayRate")}
                  IconComponent={() => getSortIcon("DayRate")}
                  style={orderBy === "DayRate" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "DayRate"}
                  // direction={
                  //   sortConfig.key === "DayRate" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("DayRate")}
                > */}
                Day Rate
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === "Hours"}
                  direction={orderBy === "Hours" ? order : "asc"}
                  onClick={() => handleSort("Hours")}
                  IconComponent={() => getSortIcon("Hours")}
                  style={orderBy === "Hours" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Hours"}
                  // direction={
                  //   sortConfig.key === "Hours" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Hours")}
                > */}
                Hours
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === "Status"}
                  direction={orderBy === "Status" ? order : "asc"}
                  onClick={() => handleSort("Status")}
                  IconComponent={() => getSortIcon("Status")}
                  style={orderBy === "Status" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Status"}
                  // direction={
                  //   sortConfig.key === "Status" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Status")}
                > */}
                Status
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === "Others"}
                  direction={orderBy === "Others" ? order : "asc"}
                  onClick={() => handleSort("Others")}
                  IconComponent={() => getSortIcon("Others")}
                  style={orderBy === "Others" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Others"}
                  // direction={
                  //   sortConfig.key === "Others" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Others")}
                > */}
                Others
                {/* </TableSortLabel> */}
              </TableCell>
              <TableCell>
                {/* <TableSortLabel
                  active={orderBy === "Total"}
                  direction={orderBy === "Total" ? order : "asc"}
                  onClick={() => handleSort("Total")}
                  IconComponent={() => getSortIcon("Total")}
                  style={orderBy === "Total" ? { color: "#007fff" } : {}}
                  // active={sortConfig.key === "Total"}
                  // direction={
                  //   sortConfig.key === "Total" ? sortConfig.direction : "asc"
                  // }
                  // onClick={() => handleSort("Total")}
                > */}
                Total Billing
                {/* </TableSortLabel> */}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <CircularProgress disableShrink />
                </TableCell>
              </TableRow>
            ) : filteredData.length > 0 ? (
              Object.keys(groupedData).map((projId, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell colSpan={7} sx={{ padding: "0px !important" }}>
                      <Box
                        className="datebox-title"
                        sx={{ padding: "13px !important", borderRadius: "0px" }}
                      >
                        <Typography>
                          {groupedData[projId][0].RowGroup}
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                  {groupedData[projId].map((val, idx) => {
                    const otherCount =
                      val?.PerDiem +
                      val?.Lodging +
                      val?.Copies +
                      val?.Misc +
                      val?.Miles * val?.MileageRate;

                    const totalValue =
                      val?.PerDiem +
                      val?.Lodging +
                      val?.Copies +
                      val?.Misc +
                      val?.Miles * val?.MileageRate +
                      (val?.Hours / 8) * val?.DayRate;
                    return (
                      <TableRow key={idx}>
                        <TableCell
                          sx={
                            val.BillingHeaderID
                              ? {
                                  color: "#007FFF !important",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }
                              : {}
                          }
                          onClick={() => handleBillingNavigate(val)}
                        >
                          {val.BillingHeaderID || "-"}
                        </TableCell>
                        <TableCell
                          sx={
                            val.UserID
                              ? {
                                  color: "#007FFF !important",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }
                              : {}
                          }
                          onClick={() => handleBrokerNavigate(val.UserID)}
                        >
                          {val.Broker || "-"}
                        </TableCell>
                        <TableCell>${val.DayRate?.toFixed(2) || "0.00"}</TableCell>
                        <TableCell>{val.Hours?.toFixed(2) || "0.00"}</TableCell>
                        <TableCell sx={{ minWidth: "180px" }}>
                          <span
                            className={
                              val.Status == "Invoice Started"
                                ? "dashboard-status-btn"
                                : val.Status == "Statement Open"
                                ? "active-btn"
                                : val.Status == "Statement Closed" ||
                                  val.Status == "Statement Ready"
                                ? "closed-btn"
                                : val.Status == "Invoice Closed"
                                ? "active-btn"
                                : ""
                            }
                          >
                            {val.Status || "-"}
                          </span>
                        </TableCell>
                        <TableCell>
                          ${otherCount ? otherCount.toFixed(2) : "0.00"}
                        </TableCell>
                        <TableCell sx={{ fontWeight: "700 !important" }}>
                          ${totalValue ? totalValue.toFixed(2) : "0.00"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </React.Fragment>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  {/* <Typography>No Record Found</Typography> */}
                  <NoRecordFound />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {filteredData.length > 0 && (
          <Pagination
            sx={{ mt: "13.5px", float: "right" }}
            shape="rounded"
            count={totalPages}
            // hidePrevButton
            // hideNextButton
            page={page}
            onChange={handlePageChange}
          />
        )}
      </TableContainer>
    </div>
  );
}
